module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/operations.54e0d4ac.svg";